import { isProductCollaborator, isProductExecutive, isTeamManager, type Role } from "@packages/core/session/roles.ts";

export const PERFORMANCE_CYCLE_CREATE_ACCESS: readonly Role[] = [isProductExecutive("wpm"), isProductCollaborator("wpm")];

export const OFFICEVIBE_SURVEY_CREATE_ACCESS: readonly Role[] = [isProductExecutive("wov"), isTeamManager];
